import { PMMilestone } from '../types/pm';
import { createProjectItemStore } from './createProjectItemStore';

export const useMilestoneStore = createProjectItemStore<PMMilestone>('milestones');
